import { vnTemplate } from '../../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate';
import { listPageSelect_template } from '~/components/templates/listPageSelect_template';
import { renderEditToggle } from '~/components/templates/editToggle';
import { renderPartnerEditFilters } from '../../recruiting/partner-edit-filters';
import { renderPartnerContractsTable, renderPartnerCreativesTable, renderPartnerQuestionsTable, renderPartnerTransmissionsTable } from '~/components/recruiting/partner-edit-tables';
import { html, LpButton, LpEditCard, LpEditGrid, LpFormField, LpIcon, LpPageHeader, raw } from '~/design-system';
const PARTNER_EDIT_SECTIONS = [
    { id: 'summary', label: 'Summary', icon: 'identification-card', requiresId: false },
    { id: 'questions', label: 'Questions', icon: 'question', requiresId: true },
    { id: 'contracts', label: 'Contracts', icon: 'file-text', requiresId: true },
    { id: 'transmissions', label: 'Transmissions', icon: 'paper-plane-tilt', requiresId: true },
    { id: 'creatives', label: 'Creatives', icon: 'image', requiresId: true },
];
const PARTNER_FILTER_CATEGORIES = [
    {
        id: 'demographics',
        label: 'Demographics',
        icon: 'users',
        title: 'Age, GPA & identity',
        description: 'Define who qualifies based on age, graduation year, academic performance, gender, and ethnicity.',
    },
    {
        id: 'geography',
        label: 'Geography',
        icon: 'map-pin',
        title: 'Location & territory',
        description: 'Restrict leads by subunit, country, US state, or specific ZIP / postal codes.',
    },
    {
        id: 'military',
        label: 'Military',
        icon: 'shield-star',
        title: 'Service background',
        description: 'Filter by branch, current status, prior service, and pay grade.',
    },
    {
        id: 'education',
        label: 'Education & citizenship',
        icon: 'graduation-cap',
        title: 'Education & legal status',
        description: 'Require a minimum education level or eligible citizenship status.',
    },
    {
        id: 'families',
        label: 'Families',
        icon: 'users-three',
        title: 'Partner families',
        description: 'Limit eligibility to leads associated with selected partner families.',
    },
];
export class adminPartnerEdit_template extends vnTemplate {
    constructor() {
        super(...arguments);
        this.filtersSnapshot = null;
    }
    /**
     * Return the template key used by the Valnet template framework.
     *
     * @return string
     */
    getTemplateName() {
        return 'adminPartnerEdit-template';
    }
    /**
     * Return the CSS classes applied to the template root element.
     *
     * @return Array<string>
     */
    getMainElementClasses() {
        return ['w-content'];
    }
    /**
     * Build the Knockout view model used by this template.
     *
     * @return any
     */
    buildViewModel() {
        const self = this;
        return {
            id: ko.observable(null),
            name: ko.observable(''),
            internalName: ko.observable(''),
            partnerType: ko.observable(''),
            partnerStatus: ko.observable('1'),
            channelId: ko.observable(''),
            displayOrder: ko.observable(''),
            versionHash: ko.observable(''),
            statuses: ko.observableArray([{ id: '1', name: 'Active' }]),
            channels: ko.observableArray([]),
            subunits: ko.observableArray([]),
            countries: ko.observableArray([]),
            usStates: ko.observableArray([]),
            services: ko.observableArray([]),
            educationLevels: ko.observableArray([]),
            citizenships: ko.observableArray([]),
            militaryStatuses: ko.observableArray([]),
            genders: ko.observableArray([]),
            servedBeforeStatuses: ko.observableArray([]),
            ethnicities: ko.observableArray([]),
            paygrades: ko.observableArray([]),
            families: ko.observableArray([]),
            selectedMinAge: ko.observable(''),
            selectedMaxAge: ko.observable(''),
            selectedMinHsGradRange: ko.observable(''),
            selectedMaxHsGradRange: ko.observable(''),
            selectedMinGPA: ko.observable(''),
            selectedSubunits: ko.observableArray([]),
            selectedCountries: ko.observableArray([]),
            selectedUSStates: ko.observableArray([]),
            selectedZipCodes: ko.observable(''),
            selectedServices: ko.observableArray([]),
            selectedEducationLevels: ko.observableArray([]),
            selectedCitizenships: ko.observableArray([]),
            selectedMilitaryStatuses: ko.observableArray([]),
            selectedGenders: ko.observableArray([]),
            selectedServedBeforeStatuses: ko.observableArray([]),
            selectedEthnicities: ko.observableArray([]),
            selectedPaygrades: ko.observableArray([]),
            selectedFamilies: ko.observableArray([]),
            parameters: ko.observableArray([]),
            unmappedParameters: ko.observableArray([]),
            questions: ko.observableArray([]),
            availableQuestions: ko.observableArray([]),
            selectedQuestionId: ko.observable(''),
            contracts: ko.observableArray([]),
            transmissions: ko.observableArray([]),
            creatives: ko.observableArray([]),
            previewVisible: ko.observable(false),
            previewCreatives: ko.observableArray([]),
            previewQuestions: ko.observableArray([]),
            filtersModalVisible: ko.observable(false),
            activeFilterCategory: ko.observable('demographics'),
            filterCategories: PARTNER_FILTER_CATEGORIES,
            activeSection: ko.observable('summary'),
            sections: PARTNER_EDIT_SECTIONS,
            onClickOpenFilters: function () { self.openFiltersModal(); },
            onClickApplyFilters: function () { self.applyFiltersModal(); },
            onClickCancelFilters: function () { self.cancelFiltersModal(); },
            onClickSelectFilterCategory: function (category) { self.selectFilterCategory(category.id); },
            onClickSection: function (section) { self.selectSection(section.id); },
            onClickBack: function () { self.caller.backToPartners(); },
            onClickSave: function () { self.caller.savePartner(); },
            onClickDelete: function () { self.caller.deletePartner(); },
            onClickPreview: function () { self.openPreview(); },
            onClickClosePreview: function () { self.closePreview(); },
            onClickAddQuestion: function () { self.addQuestionToPartner(); },
            onClickEditQuestion: function (row) { self.caller.editPartnerQuestion(row); },
            onClickRemoveQuestion: function (row) { self.removeQuestionFromPartner(row); },
            onQuestionDragDrop: function (dragged, target) { self.reorderQuestion(dragged, target); },
            onClickEditContract: function (row) { self.caller.editPartnerContract(row); },
            onClickAddContract: function () { self.caller.createPartnerContract(); },
            onClickEditTransmission: function (row) { self.caller.editPartnerTransmission(row); },
            onClickAddCreative: function () { self.caller.addPartnerCreative(); },
            onClickEditCreative: function (row) { self.caller.editPartnerCreative(row); },
            getQuestionLabel: function (question) { return self.getQuestionLabel(question); },
            getQuestionInputType: function (question) { return self.getQuestionInputType(question); },
            getQuestionAnswers: function (question) { return self.activeSorted(question && question.answers ? question.answers : []); },
            getAnswerLabel: function (answer) { return self.getAnswerLabel(answer); },
            isQuestionRequired: function (question) { return self.isQuestionRequired(question); },
        };
    }
    initPartial() {
        const self = this;
        const vm = this.getTemplateViewModel();
        this.channelSelect = new listPageSelect_template('adminPartnerChannelSelect', vm, this.caller);
        this.channelSelect.setLabel('Channel');
        this.channelSelect.setFormField(true);
        this.channelSelect.setOptions([{ id: '', name: 'Select channel' }]);
        this.channelSelect.bindValue(vm.channelId);
        this.questionSelect = new listPageSelect_template('adminPartnerQuestionSelect', vm, this.caller);
        this.questionSelect.setLabel('Question');
        this.questionSelect.setFormField(true);
        this.questionSelect.setOptions([{ id: '', name: 'Select a question' }]);
        this.questionSelect.setSearchEnabled(true, 'Search by code or label');
        this.questionSelect.setPlainList(true);
        this.questionSelect.bindValue(vm.selectedQuestionId);
        this.genderSelect = this.createFilterMultiSelect('adminPartnerGenderSelect', 'Gender', vm.selectedGenders);
        this.ethnicitySelect = this.createFilterMultiSelect('adminPartnerEthnicitySelect', 'Ethnicity', vm.selectedEthnicities);
        this.subunitSelect = this.createFilterMultiSelect('adminPartnerSubunitSelect', 'Geographic subunits', vm.selectedSubunits);
        this.countrySelect = this.createFilterMultiSelect('adminPartnerCountrySelect', 'Countries', vm.selectedCountries);
        this.usStateSelect = this.createFilterMultiSelect('adminPartnerUsStateSelect', 'US states', vm.selectedUSStates);
        this.serviceSelect = this.createFilterMultiSelect('adminPartnerServiceSelect', 'Branch of service', vm.selectedServices);
        this.militaryStatusSelect = this.createFilterMultiSelect('adminPartnerMilitaryStatusSelect', 'Service status', vm.selectedMilitaryStatuses);
        this.servedBeforeSelect = this.createFilterMultiSelect('adminPartnerServedBeforeSelect', 'Prior service', vm.selectedServedBeforeStatuses);
        this.paygradeSelect = this.createFilterMultiSelect('adminPartnerPaygradeSelect', 'Pay grade', vm.selectedPaygrades);
        this.educationLevelSelect = this.createFilterMultiSelect('adminPartnerEducationSelect', 'Education level', vm.selectedEducationLevels);
        this.citizenshipSelect = this.createFilterMultiSelect('adminPartnerCitizenshipSelect', 'Citizenship status', vm.selectedCitizenships);
        this.familySelect = this.createFilterMultiSelect('adminPartnerFamilySelect', 'Eligible families', vm.selectedFamilies);
        vm.filterSummaryItems = ko.computed(function () {
            return self.getFilterSummaryItems();
        });
        vm.filterCategoryCounts = ko.computed(function () {
            return self.getFilterCategoryCounts();
        });
        vm.hasActiveFilters = ko.computed(function () {
            return self.getFilterSummaryItems().length > 0;
        });
        vm.activeFilterCount = ko.computed(function () {
            return self.getFilterSummaryItems().length;
        });
        vm.questions.subscribe(function () {
            self.updateAvailableQuestionOptions();
        });
        vm.activeFilterCategoryMeta = ko.computed(function () {
            const activeId = vm.activeFilterCategory();
            return vm.filterCategories.find(function (category) {
                return category.id === activeId;
            }) || vm.filterCategories[0];
        });
    }
    /**
     * Return the HTML markup for this template.
     *
     * @return string
     */
    getTemplateHtml() {
        return `
            ${LpPageHeader({
            title: html `<span data-bind="text: id() ? 'Edit Partner' : 'New Partner'"></span>`,
            description: 'Manage partner setup, filters, questions, contracts, transmissions, and creatives.',
            icon: 'users',
            actions: html `
                    ${LpButton({
                label: 'Back',
                prefixIcon: 'arrow-left',
                size: 'base',
                variant: 'secondary',
                attributes: {
                    'data-bind': 'click: onClickBack',
                },
            })}
                    ${LpButton({
                label: 'Preview',
                prefixIcon: 'eye',
                size: 'base',
                variant: 'secondary',
                attributes: {
                    'data-bind': 'visible: id, click: onClickPreview',
                },
            })}
                    ${LpButton({
                label: 'Delete',
                prefixIcon: 'trash',
                size: 'base',
                variant: 'secondary',
                attributes: {
                    'data-bind': 'visible: id, click: onClickDelete',
                },
            })}
                    ${LpButton({
                label: 'Save',
                prefixIcon: 'check',
                size: 'base',
                variant: 'primary',
                attributes: {
                    'data-bind': 'click: onClickSave',
                },
            })}
                `,
        })}

            <div class="edit-page">
                <div class="partner-edit-toolbar">
                    <nav class="edit-nav edit-nav--tabs" aria-label="Partner sections">
                        <!-- ko foreach: sections -->
                        <button
                            class="edit-nav__item"
                            type="button"
                            data-bind="
                                visible: !requiresId || $parent.id(),
                                click: $parent.onClickSection,
                                css: { 'is-active': $parent.activeSection() === id }
                            "
                        >
                            <!-- ko if: icon -->
                            <i data-lp-component="Icon" data-icon-weight="regular" aria-hidden="true" data-bind="attr: { class: 'edit-nav__icon lp-icon ph ph-' + icon }"></i>
                            <!-- /ko -->
                            <span class="edit-nav__label" data-bind="text: label"></span>
                        </button>
                        <!-- /ko -->
                    </nav>
                    <div class="partner-filters-configure">
                        ${LpButton({
            label: 'Filters',
            variant: 'primary',
            prefixIcon: 'funnel',
            className: 'partner-filters-configure__button',
            attributes: {
                'data-bind': 'click: onClickOpenFilters',
            },
        })}
                    </div>
                </div>

                ${LpEditCard({
            title: 'Partner Summary',
            description: 'Basic configuration of this partner.',
            attributes: {
                'data-bind': "visible: activeSection() === 'summary'",
            },
            children: LpEditGrid({
                children: html `
                            ${LpFormField({
                    label: 'Display Name',
                    required: true,
                    children: raw('<input class="edit-input" type="text" placeholder="Name shown to leads" data-bind="value: name" />'),
                })}
                            ${LpFormField({
                    label: 'Internal Name',
                    required: true,
                    children: raw('<input class="edit-input" type="text" placeholder="Internal reference name" data-bind="value: internalName" />'),
                })}
                            ${LpFormField({
                    label: 'Channel',
                    children: raw(this.channelSelect.getHtmlBuild()),
                })}
                            ${LpFormField({
                    label: 'Status',
                    required: true,
                    children: raw(`
                                    <div class="edit-toggles" data-bind="foreach: statuses">
                                        ${renderEditToggle({
                        selectedBinding: '$parent.partnerStatus() == id',
                        inputHtml: '<input type="radio" name="partnerStatus" data-bind="checked: $parent.partnerStatus, attr: { value: id }" />',
                        labelHtml: '<span data-bind="text: name"></span>',
                    })}
                                    </div>
                                `),
                })}
                            ${LpFormField({
                    label: 'Partner Type',
                    children: raw('<input class="edit-input" type="text" placeholder="Partner type" data-bind="value: partnerType" />'),
                })}
                            ${LpFormField({
                    label: 'Display Order',
                    children: raw('<input class="edit-input" type="number" placeholder="Sort order" data-bind="value: displayOrder" />'),
                })}
                            ${LpFormField({
                    label: 'Version Hash',
                    className: 'edit-span',
                    children: raw('<input class="edit-input" type="text" placeholder="Version hash" data-bind="value: versionHash" />'),
                })}
                        `,
            }),
        })}

                

                <section class="edit-card" data-bind="visible: id() && activeSection() === 'questions'">
                    <div class="edit-card__header">
                        <div>
                            <h2>Questions</h2>
                            <p>Configure questions for this partner.</p>
                        </div>
                    </div>
                    <div class="edit-card__body">
                            <div class="partner-edit-picker">
                                <div class="form-group">
                                    <label class="form-label">Available Question</label>
                                    ${this.questionSelect.getHtmlBuild()}
                                </div>
                                ${LpButton({
            label: 'Add Question',
            prefixIcon: 'plus',
            size: 'base',
            variant: 'primary',
            attributes: {
                'data-bind': 'click: onClickAddQuestion',
            },
        })}
                            </div>

                            ${renderPartnerQuestionsTable()}
                    </div>
                </section>

                <section class="edit-card" data-bind="visible: id() && activeSection() === 'contracts'">
                    <div class="edit-card__header">
                        <div>
                            <h2>Contracts</h2>
                            <p>View active contracts associated with this partner.</p>
                        </div>
                        <div class="edit-card__actions">
                            ${LpButton({
            label: 'Add Contract',
            prefixIcon: 'plus',
            size: 'sm',
            variant: 'secondary',
            attributes: {
                'data-bind': 'click: onClickAddContract',
            },
        })}
                        </div>
                    </div>
                    <div class="edit-card__body">
                            <div class="partner-edit-toolbar-row">
                                <p class="partner-edit-hint">Only active contracts are shown. Contract details and quotas are managed on the standalone Contracts page.</p>
                            </div>
                            ${renderPartnerContractsTable()}
                    </div>
                </section>

                <section class="edit-card" data-bind="visible: id() && activeSection() === 'transmissions'">
                    <div class="edit-card__header">
                        <div>
                            <h2>Transmissions</h2>
                            <p>View associated transmissions.</p>
                        </div>
                    </div>
                    <div class="edit-card__body">
                            ${renderPartnerTransmissionsTable()}
                    </div>
                </section>

                <section class="edit-card" data-bind="visible: id() && activeSection() === 'creatives'">
                    <div class="edit-card__header">
                        <div>
                            <h2>Creatives</h2>
                            <p>View creatives configured for this partner.</p>
                        </div>
                        <div class="edit-card__actions">
                            ${LpButton({
            label: 'Add Creative',
            prefixIcon: 'plus',
            size: 'sm',
            variant: 'secondary',
            attributes: {
                'data-bind': 'visible: creatives().length === 0, click: onClickAddCreative',
            },
        })}
                        </div>
                    </div>
                    <div class="edit-card__body">
                            ${renderPartnerCreativesTable()}
                    </div>
                </section>

                ${renderPartnerEditFilters({
            selects: {
                gender: raw(this.genderSelect.getHtmlBuild()),
                ethnicity: raw(this.ethnicitySelect.getHtmlBuild()),
                subunit: raw(this.subunitSelect.getHtmlBuild()),
                country: raw(this.countrySelect.getHtmlBuild()),
                usState: raw(this.usStateSelect.getHtmlBuild()),
                service: raw(this.serviceSelect.getHtmlBuild()),
                militaryStatus: raw(this.militaryStatusSelect.getHtmlBuild()),
                servedBefore: raw(this.servedBeforeSelect.getHtmlBuild()),
                paygrade: raw(this.paygradeSelect.getHtmlBuild()),
                educationLevel: raw(this.educationLevelSelect.getHtmlBuild()),
                citizenship: raw(this.citizenshipSelect.getHtmlBuild()),
                family: raw(this.familySelect.getHtmlBuild()),
            },
        })}

            <div class="partner-preview-backdrop" data-bind="visible: previewVisible, click: onClickClosePreview">
                <div class="partner-preview-dialog" data-bind="click: function () { return true; }, clickBubble: false">
                    <div class="partner-preview-header">
                        <h3>Offer Preview</h3>
                        <button class="button" data-color="secondary" data-size="sm" type="button" data-bind="click: onClickClosePreview">
                            <span class="button__content">Close</span>
                        </button>
                    </div>
                    <div class="partner-preview-body">
                        <div data-bind="visible: previewCreatives().length > 0, foreach: previewCreatives">
                            <div class="partner-preview-offer">
                                <div>
                                    <img data-bind="visible: smallIconUrl, attr: { src: smallIconUrl }" alt="Creative icon" />
                                </div>
                                <div>
                                    <div class="partner-preview-offer-title" data-bind="text: $parent.name"></div>
                                    <div data-bind="text: $data.descShortLabel || $data.descShort || $data.shortDescription || $data.partnerTitle || ''"></div>
                                </div>
                            </div>
                        </div>
                        <div class="partner-edit-empty" data-bind="visible: previewCreatives().length === 0">No active creatives configured.</div>

                        <div class="questions standard" data-bind="foreach: previewQuestions">
                            <div class="partner-preview-question" data-bind="css: $parent.getQuestionInputType($data)">
                                <label data-bind="text: $parent.getQuestionLabel($data), css: { required: $parent.isQuestionRequired($data) }"></label>
                                <div data-bind="visible: $parent.getQuestionInputType($data) === 'checkbox'">
                                    <ul data-bind="foreach: $parent.getQuestionAnswers($data)">
                                        <li>
                                            <span class="checkboxLabel" data-bind="text: $parents[1].getAnswerLabel($data)"></span>
                                            <input autocomplete="off" type="checkbox" data-bind="attr: { value: id }" />
                                        </li>
                                    </ul>
                                </div>
                                <div data-bind="visible: $parent.getQuestionInputType($data) === 'radio'">
                                    <ul data-bind="foreach: $parent.getQuestionAnswers($data)">
                                        <li>
                                            <input autocomplete="off" type="radio" data-bind="attr: { value: id, name: 'preview-question-' + $parent.id }" />
                                            <span data-bind="text: $parents[1].getAnswerLabel($data)"></span>
                                        </li>
                                    </ul>
                                </div>
                                <div data-bind="visible: $parent.getQuestionInputType($data) === 'select'">
                                    <select autocomplete="off" class="standard" data-bind="foreach: $parent.getQuestionAnswers($data)">
                                        <option data-bind="text: $parents[1].getAnswerLabel($data), attr: { value: id }"></option>
                                    </select>
                                </div>
                                <div data-bind="visible: $parent.getQuestionInputType($data) === 'text'">
                                    <input autocomplete="off" type="text" />
                                </div>
                                <div data-bind="visible: $parent.getQuestionInputType($data) === 'hidden'">
                                    <input autocomplete="off" type="hidden" data-bind="attr: { value: $parent.id() }" />
                                </div>
                            </div>
                        </div>
                        <div class="partner-edit-empty" data-bind="visible: previewQuestions().length === 0">No active questions configured.</div>
                    </div>
                   
                </div>
            </div>
            </div>
        `;
    }
    /**
     * Apply reference data returned by the API to the view model.
     *
     * @param references any
     * @return void
     */
    setReferences(references) {
        references = references || {};
        const vm = this.getTemplateViewModel();
        vm.statuses(this.normalizeOptions(references.statuses, [{ id: '1', name: 'Active' }]));
        const channels = this.normalizeOptions(references.channels);
        vm.channels(channels);
        this.channelSelect.setOptions([
            { id: '', name: 'Select channel' },
            ...channels,
        ]);
        vm.subunits(this.normalizeOptions(references.subunits));
        vm.countries(this.normalizeOptions(references.countries));
        vm.usStates(this.normalizeOptions(references.usStates));
        vm.services(this.normalizeOptions(references.services));
        vm.educationLevels(this.normalizeOptions(references.educationLevels));
        vm.citizenships(this.normalizeOptions(references.citizenships));
        vm.militaryStatuses(this.normalizeOptions(references.militaryStatuses));
        vm.genders(this.normalizeOptions(references.genders));
        vm.servedBeforeStatuses(this.normalizeOptions(references.servedBeforeStatuses));
        vm.ethnicities(this.normalizeOptions(references.ethnicities));
        vm.paygrades(this.normalizeOptions(references.paygrades));
        vm.families(this.normalizeOptions(references.families));
        this.genderSelect.setOptions(vm.genders());
        this.ethnicitySelect.setOptions(vm.ethnicities());
        this.subunitSelect.setOptions(vm.subunits());
        this.countrySelect.setOptions(vm.countries());
        this.usStateSelect.setOptions(vm.usStates());
        this.serviceSelect.setOptions(vm.services());
        this.militaryStatusSelect.setOptions(vm.militaryStatuses());
        this.servedBeforeSelect.setOptions(vm.servedBeforeStatuses());
        this.paygradeSelect.setOptions(vm.paygrades());
        this.educationLevelSelect.setOptions(vm.educationLevels());
        this.citizenshipSelect.setOptions(vm.citizenships());
        this.familySelect.setOptions(vm.families());
        vm.availableQuestions((references.availableQuestions || []).map((question) => this.mapQuestionForDisplay(question)));
        this.updateAvailableQuestionOptions();
    }
    /**
     * Set partner on the view model.
     *
     * @param partner any
     * @return void
     */
    setPartner(partner) {
        const vm = this.getTemplateViewModel();
        const filterValues = this.mapFilterParameters(partner && partner.parameters ? partner.parameters : []);
        vm.id(partner && partner.id ? Number(partner.id) : null);
        vm.name(partner && partner.name ? partner.name : '');
        vm.internalName(partner && partner.internalName ? partner.internalName : '');
        vm.partnerType(partner && partner.partnerType ? partner.partnerType : '');
        vm.partnerStatus(partner && typeof partner.partnerStatus !== 'undefined' && partner.partnerStatus !== null ? String(partner.partnerStatus) : '1');
        vm.channelId(partner && partner.channelId ? String(partner.channelId) : '');
        vm.displayOrder(partner && typeof partner.displayOrder !== 'undefined' && partner.displayOrder !== null ? Number(partner.displayOrder) : '');
        vm.versionHash(partner && partner.versionHash ? partner.versionHash : '');
        vm.selectedMinAge(filterValues.selectedMinAge);
        vm.selectedMaxAge(filterValues.selectedMaxAge);
        vm.selectedMinHsGradRange(filterValues.selectedMinHsGradRange);
        vm.selectedMaxHsGradRange(filterValues.selectedMaxHsGradRange);
        vm.selectedMinGPA(filterValues.selectedMinGPA);
        vm.selectedSubunits(filterValues.selectedSubunits);
        vm.selectedCountries(this.syncSelectedOptions(filterValues.selectedCountries, vm.countries));
        vm.selectedUSStates(filterValues.selectedUSStates);
        vm.selectedZipCodes(filterValues.selectedZipCodes.join('\n'));
        vm.selectedServices(this.syncSelectedOptions(filterValues.selectedServices, vm.services));
        vm.selectedEducationLevels(this.syncSelectedOptions(filterValues.selectedEducationLevels, vm.educationLevels));
        vm.selectedCitizenships(filterValues.selectedCitizenships);
        vm.selectedMilitaryStatuses(filterValues.selectedMilitaryStatuses);
        vm.selectedGenders(filterValues.selectedGenders);
        vm.selectedServedBeforeStatuses(filterValues.selectedServedBeforeStatuses);
        vm.selectedEthnicities(filterValues.selectedEthnicities);
        vm.selectedPaygrades(this.syncSelectedOptions(filterValues.selectedPaygrades, vm.paygrades));
        vm.selectedFamilies(this.normalizeArray((partner && partner.families ? partner.families : []).map((family) => family.id)));
        vm.parameters(partner && partner.parameters ? partner.parameters : []);
        vm.unmappedParameters(filterValues.unmappedParameters);
        vm.questions(this.normalizeQuestionOrder((partner && partner.questions ? partner.questions : []).map((question) => this.mapQuestionForDisplay(question))));
        vm.contracts(partner && partner.contracts ? partner.contracts : []);
        vm.transmissions((partner && partner.transmissions ? partner.transmissions : []).map((transmission) => ({
            ...transmission,
            liveLabel: Number(transmission.live || 0) === 1 ? 'Yes' : 'No',
        })));
        vm.creatives((partner && partner.creatives ? partner.creatives : []).map((creative) => ({
            ...creative,
            descShortLabel: String(creative.descShort || creative.shortDescription || '')
                .replace(/<br\s*\/?>/gi, ' ')
                .replace(/\s+/g, ' ')
                .trim(),
            activeLabel: Number(creative.status || creative.creativeStatus || 0) === 1 ? 'Yes' : '',
            smallIconUrl: creative.imageSmall ? 'data:image/png;base64,' + creative.imageSmall : '',
        })));
        const activeSection = vm.activeSection();
        const activeMeta = PARTNER_EDIT_SECTIONS.find((section) => section.id === activeSection);
        if (!activeMeta || (!vm.id() && activeMeta.requiresId)) {
            vm.activeSection('summary');
        }
    }
    /**
     * Build the save payload from the current view model state.
     *
     * @return any
     */
    getPayload() {
        const vm = this.getTemplateViewModel();
        return {
            id: vm.id(),
            name: vm.name(),
            internalName: vm.internalName(),
            partnerType: vm.partnerType(),
            partnerStatus: Number(vm.partnerStatus()),
            channelId: vm.channelId(),
            displayOrder: vm.displayOrder(),
            versionHash: vm.versionHash(),
            parameters: vm.parameters() || [],
            questions: this.normalizeQuestionOrder(vm.questions() || []),
            creatives: vm.creatives() || [],
            families: this.normalizeArray(vm.selectedFamilies()).map((id) => ({ id: Number(id) })),
            filters: {
                selectedMinAge: vm.selectedMinAge(),
                selectedMaxAge: vm.selectedMaxAge(),
                selectedMinHsGradRange: vm.selectedMinHsGradRange(),
                selectedMaxHsGradRange: vm.selectedMaxHsGradRange(),
                selectedMinGPA: vm.selectedMinGPA(),
                selectedSubunits: this.normalizeArray(vm.selectedSubunits()),
                selectedCountries: this.normalizeArray(vm.selectedCountries()),
                selectedUSStates: this.normalizeArray(vm.selectedUSStates()),
                selectedZipCodes: vm.selectedZipCodes(),
                selectedServices: this.normalizeArray(vm.selectedServices()),
                selectedEducationLevels: this.normalizeArray(vm.selectedEducationLevels()),
                selectedCitizenships: this.normalizeArray(vm.selectedCitizenships()),
                selectedMilitaryStatuses: this.normalizeArray(vm.selectedMilitaryStatuses()),
                selectedGenders: this.normalizeArray(vm.selectedGenders()),
                selectedServedBeforeStatuses: this.normalizeArray(vm.selectedServedBeforeStatuses()),
                selectedEthnicities: this.normalizeArray(vm.selectedEthnicities()),
                selectedPaygrades: this.normalizeArray(vm.selectedPaygrades()),
                selectedFamilies: this.normalizeArray(vm.selectedFamilies()),
            },
        };
    }
    /**
     * Handle normalize options.
     *
     * @param options any
     * @param fallback Array<any>
     * @return Array<any>
     */
    createFilterMultiSelect(id, label, value) {
        const select = new listPageSelect_template(id, this.getTemplateViewModel(), this.caller);
        select.setLabel(label);
        select.setFormField(true);
        select.setMulti(true);
        select.bindValues(value);
        return select;
    }
    normalizeOptions(options, fallback = []) {
        let rows = options;
        if (!Array.isArray(rows)) {
            rows = rows && typeof rows === 'object'
                ? Object.keys(rows).map((key) => ({ id: key, name: rows[key] }))
                : [];
        }
        if (!rows.length) {
            rows = fallback;
        }
        return rows.map((option) => ({
            id: String(typeof option.id !== 'undefined' ? option.id : option.code),
            name: String(option.name || option.label || option.value || ''),
        }));
    }
    /**
     * Handle normalize array.
     *
     * @param value any
     * @return Array<string>
     */
    normalizeArray(value) {
        const values = Array.isArray(value) ? value : [value];
        return Array.from(new Set(values
            .filter((item) => item !== null && typeof item !== 'undefined' && item !== '')
            .map((item) => String(item))));
    }
    /**
     * Handle sync selected options.
     *
     * @param values any
     * @param optionsObservable any
     * @return Array<string>
     */
    syncSelectedOptions(values, optionsObservable) {
        const selectedValues = this.normalizeArray(values);
        const options = typeof optionsObservable === 'function' ? (optionsObservable() || []) : [];
        const selected = selectedValues.map((value) => {
            const valueKey = this.normalizeOptionKey(value);
            const valueAliases = this.getOptionAliases(valueKey);
            const matchedOption = options.filter((option) => valueAliases.indexOf(this.normalizeOptionKey(option.id)) !== -1)[0];
            return matchedOption ? String(matchedOption.id) : String(value);
        });
        selected.forEach((value) => {
            const exists = (optionsObservable() || []).some((option) => String(option.id) === String(value));
            if (!exists) {
                optionsObservable.push({
                    id: String(value),
                    name: String(value),
                });
            }
        });
        return Array.from(new Set(selected));
    }
    /**
     * Handle normalize option key.
     *
     * @param value any
     * @return string
     */
    normalizeOptionKey(value) {
        return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    }
    /**
     * Return option aliases.
     *
     * @param valueKey string
     * @return Array<string>
     */
    getOptionAliases(valueKey) {
        const aliases = {
            USA: ['USA', 'ARMY'],
            ARMY: ['ARMY', 'USA'],
            USN: ['USN', 'NAVY'],
            NAVY: ['NAVY', 'USN'],
            USAF: ['USAF', 'AIRFORCE', 'AF'],
            AF: ['AF', 'USAF', 'AIRFORCE'],
            AIRFORCE: ['AIRFORCE', 'USAF', 'AF'],
            USMC: ['USMC', 'MARINES', 'MARINECORPS'],
            MARINES: ['MARINES', 'USMC', 'MARINECORPS'],
            MARINECORPS: ['MARINECORPS', 'USMC', 'MARINES'],
            USCG: ['USCG', 'COASTGUARD'],
            COASTGUARD: ['COASTGUARD', 'USCG'],
            USSF: ['USSF', 'SPACEFORCE'],
            SPACEFORCE: ['SPACEFORCE', 'USSF'],
        };
        return aliases[valueKey] || [valueKey];
    }
    /**
     * Handle map question for display.
     *
     * @param question any
     * @return any
     */
    mapQuestionForDisplay(question) {
        const label = question && question.configuration && question.configuration.label
            ? question.configuration.label
            : (question && question.questionCode ? question.questionCode : '');
        const inputType = question && question.configuration ? question.configuration.inputType : null;
        const questionType = inputType && inputType.inputType
            ? inputType.inputType
            : (inputType && inputType.name ? inputType.name : '');
        const questionTypeLabel = questionType === 'Select type' ? '' : questionType;
        return {
            ...question,
            id: question && question.id ? Number(question.id) : null,
            questionName: label ? label : 'Question #' + (question && question.id ? question.id : ''),
            questionTypeLabel,
            requiredLabel: question && question.configuration && question.configuration.required ? 'Yes' : 'No',
            activeLabel: question && question.active ? 'Yes' : 'No',
            answerCount: question && typeof question.answerCount !== 'undefined' ? question.answerCount : '',
        };
    }
    /**
     * Refresh available question select options from local search and assigned state.
     *
     * @return void
     */
    updateAvailableQuestionOptions() {
        const vm = this.getTemplateViewModel();
        const assignedIds = new Set((vm.questions() || []).map((question) => Number(question.id)));
        const options = (vm.availableQuestions() || [])
            .filter((question) => !assignedIds.has(Number(question.id)))
            .map((question) => ({
            id: question.id,
            name: this.getQuestionOptionLabel(question),
        }));
        this.questionSelect.setOptions([
            { id: '', name: options.length > 0 ? 'Select a question' : 'No matching questions' },
            ...options,
        ]);
        const selectedId = Number(vm.selectedQuestionId());
        if (selectedId && !options.some((option) => Number(option.id) === selectedId)) {
            vm.selectedQuestionId('');
        }
    }
    /**
     * Return the available question dropdown label.
     *
     * @param question any
     * @return string
     */
    getQuestionOptionLabel(question) {
        const code = String(question && question.questionCode ? question.questionCode : '').trim();
        const name = String(question && question.questionName ? question.questionName : '').trim();
        if (code !== '' && name !== '' && code.toLowerCase() !== name.toLowerCase()) {
            return code + ' - ' + name;
        }
        return name || code || ('Question #' + (question && question.id ? question.id : ''));
    }
    /**
     * Handle add question to partner.
     *
     * @return void
     */
    addQuestionToPartner() {
        const vm = this.getTemplateViewModel();
        const questionId = Number(vm.selectedQuestionId());
        if (!questionId) {
            alert('Select a question to add.');
            return;
        }
        if ((vm.questions() || []).some((question) => Number(question.id) === questionId)) {
            alert('This question is already assigned to the partner.');
            return;
        }
        const question = (vm.availableQuestions() || []).filter((availableQuestion) => Number(availableQuestion.id) === questionId)[0];
        if (!question) {
            alert('Unable to find the selected question.');
            return;
        }
        vm.questions.push(this.mapQuestionForDisplay(question));
        vm.questions(this.normalizeQuestionOrder(vm.questions() || []));
        vm.selectedQuestionId('');
    }
    /**
     * Handle remove question from partner.
     *
     * @param row any
     * @return void
     */
    removeQuestionFromPartner(row) {
        const questions = this.getTemplateViewModel().questions;
        questions.remove(row);
        questions(this.normalizeQuestionOrder(questions() || []));
    }
    /**
     * Reorder partner questions after drag/drop.
     *
     * @param dragged any
     * @param target any
     * @return void
     */
    reorderQuestion(dragged, target) {
        if (!dragged || !target || dragged === target) {
            return;
        }
        const questions = this.getTemplateViewModel().questions;
        const rows = questions() || [];
        const fromIndex = rows.indexOf(dragged);
        const toIndex = rows.indexOf(target);
        if (fromIndex < 0 || toIndex < 0 || fromIndex === toIndex) {
            return;
        }
        rows.splice(fromIndex, 1);
        rows.splice(toIndex, 0, dragged);
        questions(this.normalizeQuestionOrder(rows));
    }
    /**
     * Keep question display orders gap-free and aligned with current array order.
     *
     * @param questions Array<any>
     * @return Array<any>
     */
    normalizeQuestionOrder(questions) {
        return (questions || []).map((question, index) => ({
            ...question,
            displayOrder: index,
        }));
    }
    /**
     * Open the partner offer preview using current in-page partner data.
     *
     * @return void
     */
    openPreview() {
        const vm = this.getTemplateViewModel();
        vm.previewCreatives(this.activeSorted(vm.creatives() || []));
        vm.previewQuestions(this.activeSorted(vm.questions() || []));
        vm.previewVisible(true);
    }
    /**
     * Close the offer preview dialog.
     *
     * @return void
     */
    closePreview() {
        this.getTemplateViewModel().previewVisible(false);
    }
    /**
     * Open the filters configuration modal and snapshot current values for cancel.
     *
     * @return void
     */
    openFiltersModal() {
        const vm = this.getTemplateViewModel();
        this.filtersSnapshot = this.captureFilterSnapshot();
        vm.activeFilterCategory('demographics');
        vm.filtersModalVisible(true);
        this.setFiltersModalBodyState(true);
    }
    /**
     * Apply filter changes and close the modal.
     *
     * @return void
     */
    applyFiltersModal() {
        this.filtersSnapshot = null;
        this.getTemplateViewModel().filtersModalVisible(false);
        this.setFiltersModalBodyState(false);
    }
    /**
     * Discard filter changes and close the modal.
     *
     * @return void
     */
    cancelFiltersModal() {
        if (this.filtersSnapshot) {
            this.restoreFilterSnapshot(this.filtersSnapshot);
            this.filtersSnapshot = null;
        }
        this.getTemplateViewModel().filtersModalVisible(false);
        this.setFiltersModalBodyState(false);
    }
    /**
     * Keep global header controls below the modal without hiding them.
     *
     * @param isOpen boolean
     * @return void
     */
    setFiltersModalBodyState(isOpen) {
        document.body.classList.toggle('partner-filters-modal-open', isOpen);
    }
    /**
     * Set the active filter category in the modal sidebar.
     *
     * @param categoryId string
     * @return void
     */
    selectFilterCategory(categoryId) {
        this.getTemplateViewModel().activeFilterCategory(categoryId);
    }
    /**
     * Activate a partner edit section tab.
     *
     * @param sectionId string
     * @return void
     */
    selectSection(sectionId) {
        this.getTemplateViewModel().activeSection(sectionId);
    }
    /**
     * Capture the current filter field values for cancel restore.
     *
     * @return any
     */
    captureFilterSnapshot() {
        const vm = this.getTemplateViewModel();
        return {
            selectedMinAge: vm.selectedMinAge(),
            selectedMaxAge: vm.selectedMaxAge(),
            selectedMinHsGradRange: vm.selectedMinHsGradRange(),
            selectedMaxHsGradRange: vm.selectedMaxHsGradRange(),
            selectedMinGPA: vm.selectedMinGPA(),
            selectedSubunits: (vm.selectedSubunits() || []).slice(),
            selectedCountries: (vm.selectedCountries() || []).slice(),
            selectedUSStates: (vm.selectedUSStates() || []).slice(),
            selectedZipCodes: vm.selectedZipCodes(),
            selectedServices: (vm.selectedServices() || []).slice(),
            selectedEducationLevels: (vm.selectedEducationLevels() || []).slice(),
            selectedCitizenships: (vm.selectedCitizenships() || []).slice(),
            selectedMilitaryStatuses: (vm.selectedMilitaryStatuses() || []).slice(),
            selectedGenders: (vm.selectedGenders() || []).slice(),
            selectedServedBeforeStatuses: (vm.selectedServedBeforeStatuses() || []).slice(),
            selectedEthnicities: (vm.selectedEthnicities() || []).slice(),
            selectedPaygrades: (vm.selectedPaygrades() || []).slice(),
            selectedFamilies: (vm.selectedFamilies() || []).slice(),
        };
    }
    /**
     * Restore filter field values from a snapshot.
     *
     * @param snapshot any
     * @return void
     */
    restoreFilterSnapshot(snapshot) {
        const vm = this.getTemplateViewModel();
        vm.selectedMinAge(snapshot.selectedMinAge);
        vm.selectedMaxAge(snapshot.selectedMaxAge);
        vm.selectedMinHsGradRange(snapshot.selectedMinHsGradRange);
        vm.selectedMaxHsGradRange(snapshot.selectedMaxHsGradRange);
        vm.selectedMinGPA(snapshot.selectedMinGPA);
        vm.selectedSubunits(snapshot.selectedSubunits || []);
        vm.selectedCountries(snapshot.selectedCountries || []);
        vm.selectedUSStates(snapshot.selectedUSStates || []);
        vm.selectedZipCodes(snapshot.selectedZipCodes);
        vm.selectedServices(snapshot.selectedServices || []);
        vm.selectedEducationLevels(snapshot.selectedEducationLevels || []);
        vm.selectedCitizenships(snapshot.selectedCitizenships || []);
        vm.selectedMilitaryStatuses(snapshot.selectedMilitaryStatuses || []);
        vm.selectedGenders(snapshot.selectedGenders || []);
        vm.selectedServedBeforeStatuses(snapshot.selectedServedBeforeStatuses || []);
        vm.selectedEthnicities(snapshot.selectedEthnicities || []);
        vm.selectedPaygrades(snapshot.selectedPaygrades || []);
        vm.selectedFamilies(snapshot.selectedFamilies || []);
    }
    /**
     * Return active filter counts grouped by modal category.
     *
     * @return Record<string, number>
     */
    getFilterCategoryCounts() {
        const vm = this.getTemplateViewModel();
        return {
            demographics: this.countActiveFilters([
                vm.selectedMinAge(),
                vm.selectedMaxAge(),
                vm.selectedMinHsGradRange(),
                vm.selectedMaxHsGradRange(),
                vm.selectedMinGPA(),
                vm.selectedGenders(),
                vm.selectedEthnicities(),
            ]),
            geography: this.countActiveFilters([
                vm.selectedSubunits(),
                vm.selectedCountries(),
                vm.selectedUSStates(),
                vm.selectedZipCodes(),
            ]),
            military: this.countActiveFilters([
                vm.selectedServices(),
                vm.selectedMilitaryStatuses(),
                vm.selectedServedBeforeStatuses(),
                vm.selectedPaygrades(),
            ]),
            education: this.countActiveFilters([
                vm.selectedEducationLevels(),
                vm.selectedCitizenships(),
            ]),
            families: this.countActiveFilters([
                vm.selectedFamilies(),
            ]),
        };
    }
    /**
     * Build human-readable summary rows for the active filters card.
     *
     * @return Array<{ label: string, value: string }>
     */
    getFilterSummaryItems() {
        const vm = this.getTemplateViewModel();
        const items = [];
        if (vm.selectedMinAge() || vm.selectedMaxAge()) {
            const minAge = vm.selectedMinAge() || '—';
            const maxAge = vm.selectedMaxAge() || '—';
            items.push({ label: 'Age range', value: minAge + ' – ' + maxAge });
        }
        if (vm.selectedMinHsGradRange() || vm.selectedMaxHsGradRange()) {
            items.push({
                label: 'High school class year',
                value: (vm.selectedMinHsGradRange() || '—') + ' – ' + (vm.selectedMaxHsGradRange() || '—'),
            });
        }
        if (vm.selectedMinGPA()) {
            items.push({ label: 'Minimum GPA', value: String(vm.selectedMinGPA()) });
        }
        this.pushMultiSelectItem(items, 'Gender', vm.selectedGenders(), vm.genders());
        this.pushMultiSelectItem(items, 'Ethnicity', vm.selectedEthnicities(), vm.ethnicities());
        this.pushMultiSelectItem(items, 'Geographic subunits', vm.selectedSubunits(), vm.subunits());
        this.pushMultiSelectItem(items, 'Countries', vm.selectedCountries(), vm.countries());
        this.pushMultiSelectItem(items, 'US states', vm.selectedUSStates(), vm.usStates());
        if (vm.selectedZipCodes()) {
            items.push({ label: 'ZIP / postal codes', value: this.formatZipCodesSummary(vm.selectedZipCodes()) });
        }
        this.pushMultiSelectItem(items, 'Branch of service', vm.selectedServices(), vm.services());
        this.pushMultiSelectItem(items, 'Service status', vm.selectedMilitaryStatuses(), vm.militaryStatuses());
        this.pushMultiSelectItem(items, 'Prior service', vm.selectedServedBeforeStatuses(), vm.servedBeforeStatuses());
        this.pushMultiSelectItem(items, 'Pay grade', vm.selectedPaygrades(), vm.paygrades());
        this.pushMultiSelectItem(items, 'Education level', vm.selectedEducationLevels(), vm.educationLevels());
        this.pushMultiSelectItem(items, 'Citizenship status', vm.selectedCitizenships(), vm.citizenships());
        this.pushMultiSelectItem(items, 'Eligible families', vm.selectedFamilies(), vm.families());
        return items;
    }
    /**
     * Format ZIP codes for the active filters summary.
     *
     * @param rawCodes string
     * @return string
     */
    formatZipCodesSummary(rawCodes) {
        const codes = String(rawCodes || '')
            .split(/[\n,]+/)
            .map((code) => code.trim())
            .filter(Boolean);
        if (!codes.length) {
            return '';
        }
        if (codes.length <= 4) {
            return codes.join(', ');
        }
        return codes.slice(0, 4).join(', ') + ' +' + (codes.length - 4) + ' more';
    }
    /**
     * Append a summary row for a multi-select filter field.
     *
     * @param items Array<{ label: string, value: string }>
     * @param label string
     * @param selectedIds any
     * @param options any
     * @return void
     */
    pushMultiSelectItem(items, label, selectedIds, options) {
        const selected = this.normalizeArray(selectedIds);
        if (!selected.length) {
            return;
        }
        const optionRows = typeof options === 'function' ? (options() || []) : (options || []);
        const names = selected
            .map((id) => {
            const match = optionRows.filter((option) => String(option.id) === String(id))[0];
            return match ? match.name : id;
        })
            .filter(Boolean);
        if (!names.length) {
            return;
        }
        items.push({
            label: label,
            value: names.join(', '),
        });
    }
    /**
     * Count how many filter fields in a group have values.
     *
     * @param values Array<any>
     * @return number
     */
    countActiveFilters(values) {
        return values.filter((value) => {
            if (Array.isArray(value)) {
                return value.length > 0;
            }
            return value !== null && typeof value !== 'undefined' && String(value).trim() !== '';
        }).length;
    }
    /**
     * Return active rows sorted by display order when present.
     *
     * @param rows Array<any>
     * @return Array<any>
     */
    activeSorted(rows) {
        return (rows || [])
            .filter((row) => this.isActiveRow(row))
            .sort((a, b) => {
            const aDisplayOrder = Number(a.displayOrder || a.display_order);
            const bDisplayOrder = Number(b.displayOrder || b.display_order);
            const aHasOrder = !isNaN(aDisplayOrder);
            const bHasOrder = !isNaN(bDisplayOrder);
            if (!aHasOrder && !bHasOrder) {
                return 0;
            }
            if (aHasOrder && !bHasOrder) {
                return 1;
            }
            if (!aHasOrder && bHasOrder) {
                return -1;
            }
            return aDisplayOrder > bDisplayOrder ? 1 : (aDisplayOrder < bDisplayOrder ? -1 : 0);
        });
    }
    /**
     * Return whether a preview row is active.
     *
     * @param row any
     * @return boolean
     */
    isActiveRow(row) {
        if (!row) {
            return false;
        }
        if (typeof row.status !== 'undefined' && row.status !== null && row.status !== '') {
            return Number(row.status) === 1;
        }
        if (typeof row.creativeStatus !== 'undefined' && row.creativeStatus !== null && row.creativeStatus !== '') {
            return Number(row.creativeStatus) === 1;
        }
        if (typeof row.active !== 'undefined' && row.active !== null && row.active !== '') {
            return Number(row.active) === 1 || row.active === true;
        }
        return true;
    }
    /**
     * Return the display label for a preview question.
     *
     * @param question any
     * @return string
     */
    getQuestionLabel(question) {
        if (question && question.configuration && question.configuration.label) {
            return String(question.configuration.label);
        }
        return String(question && question.questionName ? question.questionName : '');
    }
    /**
     * Return the input type used by a preview question.
     *
     * @param question any
     * @return string
     */
    getQuestionInputType(question) {
        const inputType = question && question.configuration && question.configuration.inputType
            ? question.configuration.inputType.inputType || question.configuration.inputType.name || question.configuration.inputType
            : question && question.inputType ? question.inputType : 'text';
        return String(inputType || 'text').toLowerCase();
    }
    /**
     * Return whether the preview question is required.
     *
     * @param question any
     * @return boolean
     */
    isQuestionRequired(question) {
        const required = question && question.configuration ? question.configuration.required : false;
        return Number(required) === 1 || required === true;
    }
    /**
     * Return the display label for a preview answer.
     *
     * @param answer any
     * @return string
     */
    getAnswerLabel(answer) {
        return String(answer && (answer.answerDisplay || answer.display || answer.label || answer.value) ? (answer.answerDisplay || answer.display || answer.label || answer.value) : '');
    }
    /**
     * Handle map filter parameters.
     *
     * @param parameters Array<any>
     * @return any
     */
    mapFilterParameters(parameters) {
        const filters = {
            selectedMinAge: '',
            selectedMaxAge: '',
            selectedMinHsGradRange: '',
            selectedMaxHsGradRange: '',
            selectedMinGPA: '',
            selectedSubunits: [],
            selectedCountries: [],
            selectedUSStates: [],
            selectedZipCodes: [],
            selectedServices: [],
            selectedEducationLevels: [],
            selectedCitizenships: [],
            selectedMilitaryStatuses: [],
            selectedGenders: [],
            selectedServedBeforeStatuses: [],
            selectedEthnicities: [],
            selectedPaygrades: [],
            unmappedParameters: [],
        };
        const scalarMap = {
            AGEMIN: 'selectedMinAge',
            AGEMAX: 'selectedMaxAge',
            HS_GRADYEAR_MINRANGE: 'selectedMinHsGradRange',
            HS_GRADYEAR_MAXRANGE: 'selectedMaxHsGradRange',
            MINGPA: 'selectedMinGPA',
            MIN_AGE: 'selectedMinAge',
            MAX_AGE: 'selectedMaxAge',
            MIN_HS_GRAD_RANGE: 'selectedMinHsGradRange',
            MAX_HS_GRAD_RANGE: 'selectedMaxHsGradRange',
            MIN_GPA: 'selectedMinGPA',
        };
        const arrayMap = {
            SUBUNIT: 'selectedSubunits',
            COUNTRY: 'selectedCountries',
            STATE: 'selectedUSStates',
            ZIP: 'selectedZipCodes',
            STATE_US: 'selectedUSStates',
            ZIP_POSTAL_CODE: 'selectedZipCodes',
            SERVICE: 'selectedServices',
            EDULEV: 'selectedEducationLevels',
            EDUCATION_LEVEL: 'selectedEducationLevels',
            CITZEN: 'selectedCitizenships',
            CITIZENSHIP: 'selectedCitizenships',
            MILSTS: 'selectedMilitaryStatuses',
            MILITARY_STATUS: 'selectedMilitaryStatuses',
            GENDER: 'selectedGenders',
            SERVED: 'selectedServedBeforeStatuses',
            SERVED_BEFORE: 'selectedServedBeforeStatuses',
            ETHNICITY: 'selectedEthnicities',
            PAYGRADE: 'selectedPaygrades',
        };
        (parameters || []).forEach((parameter) => {
            const type = String(parameter.parameterType || parameter.type || '').toUpperCase();
            const value = typeof parameter.parameterCode !== 'undefined' ? parameter.parameterCode : parameter.value;
            if (value === null || typeof value === 'undefined' || value === '') {
                return;
            }
            if (typeof scalarMap[type] !== 'undefined') {
                filters[scalarMap[type]] = String(value);
                return;
            }
            if (typeof arrayMap[type] !== 'undefined') {
                filters[arrayMap[type]].push(String(value));
                return;
            }
            filters.unmappedParameters.push({
                type: parameter.parameterType || parameter.type || '',
                value: value,
            });
        });
        return filters;
    }
}
